/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { getCenterCoord } from '../utils/PRIVATE_meterUtils';
import { ColorProps } from '../utils/UNSAFE_interpolations/colors';
import { DvtThresholdsColors, getDvtThresholdColor } from '../utils/UNSAFE_dvtCommonUtils';
import { styles } from './themes/MeterCircleStyles.css';
import { classNames } from '../utils/UNSAFE_classNames';

type getCenterCoordParamType = Parameters<typeof getCenterCoord>;

export type CircularReferenceLineProps = {
  color?: ColorProps['color'] | DvtThresholdsColors;
  angle: number;
  radius: string;
  length: string;
  section: getCenterCoordParamType[0];
};

export function CircularReferenceLine({
  color,
  angle,
  radius,
  length,
  section = 'full'
}: CircularReferenceLineProps) {
  const centerCoord = getCenterCoord(section);
  const yOffset = `calc(${centerCoord.y * 100}% - ((${Math.sin(
    (angle * 2 * Math.PI) / 360
  )} * ${radius})))`;
  const xOffset = `calc(${centerCoord.x * 100}%  + ((${Math.cos(
    (angle * 2 * Math.PI) / 360
  )} * ${radius})))`;
  return (
    <div
      class={classNames([
        styles.referenceBaseLineStyle,
        color ? undefined : styles.referenceBorderStyle
      ])}
      style={{
        left: xOffset,
        top: yOffset,
        width: `calc(${length})`,
        transform: `translate(0, -1px) rotate(${360 - angle}deg)`,
        backgroundColor: color ? getDvtThresholdColor(color) : undefined
      }}></div>
  );
}
